<template>
<div>
  <highcharts v-if="!isEmptyData" style="height: 95%; width: 100%; margin-top: 15px;" class="fit-highchart" :options="options" ref="highchart" />
  <div v-else class="empty_box">
    <span class="empty_text">데이터가 없습니다.</span>
  </div>
</div>
</template>

<script>
import { mapGetters } from 'vuex';
import { isNil, isEmpty, cloneDeep, isEqual, map } from 'lodash';
import AmsResultAPI from '@/api/ams/result';
import { pieOptions } from '@/constants/chart-options';

export default {
  name: 'WResultStatusPieChart',
  computed: {
    ...mapGetters(['analysisDateParams']),
    resultStatusFilters() {
      const resultStatusFilters = this.filterList.filter((item) => isEqual(item.type, 'resultStatus'));
      const result = map(resultStatusFilters, 'label');
      return result;
    },
  },
  props: {
    active: {
      type: Boolean,
      default: false,
    },
    resultType: {
      type: String,
      default: 'TRIGGER',
    },
    filterList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      options: cloneDeep(pieOptions),
      isEmptyData: true,
      customLegendOptions: {},
      isBlack: true,
      colorObject: {
        성공: 'rgb(86, 139, 210)',
        실패: 'rgb(253, 116, 132)',
        부분성공: 'rgb(247, 186, 0)',
        진행중: 'rgb(209, 209, 209)',
      },
    };
  },
  watch: {
    active: {
      handler(value) {
        if (!isNil(value) && value) {
          this.loadData();
        }
      },
      immediate: true,
    },
    analysisDateParams() {
      this.loadData();
    },
  },
  created() {
    this.setChartOption();
  },
  methods: {
    loadData() {
      if (!this.active) {
        return;
      }
      const params = {
        startDatetime: this.analysisDateParams.startDatetime,
        endDatetime: this.analysisDateParams.endDatetime,
      };
      if (isEqual(this.resultType, 'TRIGGER')) {
        AmsResultAPI.getResultCountListByResultStatus(params).then((response) => {
          const result = response.data;
          if (result.success) {
            this.setChartData(cloneDeep(result.data));
          }
        });
      } else {
        AmsResultAPI.getRawDataResultCountListByResultStatus(params).then((response) => {
          const result = response.data;
          if (result.success) {
            this.setChartData(cloneDeep(result.data));
          }
        });
      }
    },
    setChartData(data) {
      this.isEmptyData = isEmpty(data);
      data.forEach((item) => {
        item.y = isNil(item.count) ? null : Number(item.count);
        item.name = isNil(item.label) ? ' ' : item.label;
        item.color = this.colorObject[item.label];
      });
      this.options.series = [
        {
          name: '건수',
          colorByPoint: true,
          data,
        },
      ];
      this.$nextTick(() => {
        if (!isEmpty(this.resultStatusFilters)) {
          const chartData = this.$refs.highchart.chart.series[0].data;
          this.resultStatusFilters.forEach((filter) => {
            const item = chartData.filter((o) => o.name === filter);
            if (!isEmpty(item)) {
              item[0].select(null, true);
            }
          });
        }
      });
    },
    setChartOption() {
      const me = this;
      this.options.chart.spacing = [0, 0, 0, 0];
      this.options.plotOptions = {
        series: {
          className: 'c-pointer',
          point: {
            events: {
              click() {
                this.slice(null);
                this.select(null, true);
                const item = {
                  ...this.options,
                  tagType: 'info',
                  type: 'resultStatus',
                };
                me.$emit('set-result-filter', item, me.resultType);
              },
            },
          },
        },
        pie: {
          dataLabels: {
            enabled: false,
          },
          innerSize: '30%',
        },
      };
    },
    deleteResultFilter(filter) {
      this.$nextTick(() => {
        if (this.$refs.highchart) {
          const data = this.$refs.highchart.chart.series[0].data;
          if (!isNil(filter)) {
            const item = data.filter((o) => o.name === filter.name);
            item[0].select(null, true);
          } else {
            data[0].select(false);
          }
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.empty_box {
  width: 100%;
  min-height: 180px;
  display: table;
  .empty_text {
    display: table-cell;
    vertical-align: middle;
    text-align: center;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/work/popup/components/ExecutionResult/components/ResultStatusPieChart.vue